module.exports = __webpack_public_path__ + "downloads/Generic_Entry_Sample.e715ef16.xlsx";